import { render, staticRenderFns } from "./GPTSuggestions.vue?vue&type=template&id=d3d2550e&scoped=true&"
import script from "./GPTSuggestions.vue?vue&type=script&lang=js&"
export * from "./GPTSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./GPTSuggestions.vue?vue&type=style&index=0&id=d3d2550e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3d2550e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCarousel } from 'vuetify/lib'
import { VCarouselItem } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListItem } from 'vuetify/lib'
import { VListItemContent } from 'vuetify/lib'
import { VListItemGroup } from 'vuetify/lib'
import { VListItemTitle } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VCard,VCardActions,VCardText,VCarousel,VCarouselItem,VDialog,VList,VListItem,VListItemContent,VListItemGroup,VListItemTitle,VTextarea})
